export default __webpack_public_path__ + "static/media/20.4f11c56a.jpg";